
import NoAccess from "./NoAccess";

const PermissionGuard = ({ children, hasAccess }) => {
  if (!hasAccess) return <NoAccess />;
  return children;
};

export default PermissionGuard;